<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    let { label, css, text, value = $bindable(), values = $bindable(), dependsOn }: FieldComponentProps = $props()

    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = $derived(values && dependsOn ? ruleEngine.resolve(dependsOn, values) : true)
</script>

{#if displayComponent}
    <div class="info-text {css ? css : ''}">
        {#if label}
            <label for="">{label}</label>
        {/if}
        {#if text}
            <p>{@html text}</p>
        {/if}
    </div>
{/if}
